var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row align-items-center",class:{ 'flex-row-reverse': _vm.reverse }},[_c('div',{staticClass:"col-md-6"},[_vm._t("column-1")],2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_vm._t("column-2")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }